import React from 'react';
import { Menu, MenuItem, Box } from '@mui/material';
import { getLabelForType } from '../data/equipmentTypes';

const MONO = "'IBM Plex Mono', monospace";

function hitLabel(hit) {
  if (hit.type === 'element') {
    const el = hit.item;
    return { primary: el.name || '(unnamed)', secondary: getLabelForType(el.elementType) };
  }
  if (hit.type === 'junction') {
    const conn = hit.item;
    return { primary: 'Insert pipe junction', secondary: conn.name || conn.relationshipType || 'pipe' };
  }
  const conn = hit.item;
  return { primary: conn.name || (conn.relationshipType || 'connection'), secondary: conn.relationshipType && conn.name ? conn.relationshipType : 'connection' };
}

// Anchored at the click point (not a DOM element) via MUI's
// anchorReference="anchorPosition" — appears when a capture-phase hit-test
// finds more than one candidate under a single click. Two independent
// consumers today: DrawingView.js's own capture-phase hit-test for normal
// canvas selection (e.g. a text_label inside an instrument bubble), and
// ConnectionCreationOverlay.js's for disambiguating connection-drawing
// hotspots (e.g. an instrument and its label sharing a bounding-box center).
const CanvasStackPicker = ({ stackPicker, onPick, onClose }) => {
  if (!stackPicker) return null;
  const { hits, anchorPosition } = stackPicker;

  return (
    <Menu
      open={Boolean(stackPicker)}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      sx={{ '& .MuiPaper-root': { background: '#0e1c39', border: '1px solid rgba(120,150,200,.3)', borderRadius: '10px', boxShadow: '0 20px 50px rgba(0,0,0,.5)', minWidth: '200px' } }}
    >
      <Box sx={{ px: '12px', py: '6px', fontFamily: MONO, fontSize: '10px', letterSpacing: '.08em', textTransform: 'uppercase', color: '#7f93b8' }}>
        {hits.length} items here
      </Box>
      {hits.map((hit, idx) => {
        const { primary, secondary } = hitLabel(hit);
        return (
          <MenuItem key={`${hit.type}-${hit.item._id}-${idx}`} onClick={() => onPick(hit)}
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '2px', fontSize: '13.5px', color: '#dce6fa', '&:hover': { background: 'rgba(120,150,200,.1)' } }}>
            <Box sx={{ fontFamily: MONO }}>{primary}</Box>
            <Box sx={{ fontSize: '11px', color: '#7f93b8' }}>{secondary}</Box>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default CanvasStackPicker;
